import { Fragment, useState } from "react";

import {
  DeleteIcon,
  PencilIcon,
  Table,
  TableData,
  TableHead,
  TableHeader,
} from "~/common/components";
import { extractFileNameFromPath } from "~/common/utils/extractFileNameFromPath";
import { ListConsentDocumentResponse } from "~/providers/types/consentDocuments";
import { formatDateToComplete } from "~/providers/utils";
import { DeleteDocumentModal } from "./DeleteDocumentModal";
import { UpdateDocumentModal } from "./UpdateDocumentModal";

interface ConsentDocumentsTableProps {
  documents: ListConsentDocumentResponse[];
}

export const ConsentDocumentsTable = ({
  documents,
}: ConsentDocumentsTableProps) => {
  const [documentToUpdate, setDocumentToUpdate] =
    useState<ListConsentDocumentResponse>();
  const [documentToDelete, setDocumentToDelete] =
    useState<ListConsentDocumentResponse>();

  const handleUpdateModalClose = () => {
    setDocumentToUpdate(undefined);
  };

  const handleDeleteModalClose = () => {
    setDocumentToDelete(undefined);
  };

  return (
    <Fragment>
      <div className="w-full overflow-x-auto rounded-xl border border-gray-200">
        <Table className="size-full table-auto">
          <TableHead className="rounded-t-xl">
            <tr>
              <TableHeader>Name</TableHeader>
              <TableHeader>File</TableHeader>
              <TableHeader>Uploaded</TableHeader>
              <TableHeader />
            </tr>
          </TableHead>
          <tbody>
            {documents.map((doc) => {
              return (
                <tr key={doc.id}>
                  <TableData>{doc.name}</TableData>
                  <TableData>
                    <a
                      className="underline"
                      href={doc.files[0].path}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {extractFileNameFromPath(doc.files[0].path)}
                    </a>
                  </TableData>
                  <TableData>
                    {formatDateToComplete(doc.files[0].created_at)}
                  </TableData>
                  <TableData>
                    <div className="flex items-center justify-end gap-2">
                      <button
                        onClick={() => {
                          setDocumentToUpdate(doc);
                        }}
                      >
                        <PencilIcon className="size-5" />
                      </button>
                      <button
                        onClick={() => {
                          setDocumentToDelete(doc);
                        }}
                      >
                        <DeleteIcon className="size-5" />
                      </button>
                    </div>
                  </TableData>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
      {documentToUpdate && (
        <UpdateDocumentModal
          show={!!documentToUpdate}
          onClose={handleUpdateModalClose}
          document={documentToUpdate}
        />
      )}
      {documentToDelete && (
        <DeleteDocumentModal
          show={!!documentToDelete}
          onClose={handleDeleteModalClose}
          document={documentToDelete}
        />
      )}
    </Fragment>
  );
};
